<template>
	<div>
		<section>
			<!-- searchbox -->
			<div class=" input-group">
				<input v-if="queryVal" readonly="true" type="text" v-model="queryVal" class="form-control"/>
				
				<div v-if="paramsSearch.btnReturn" class="input-group-preppend">
					<button class="btn btn-info" @click="onClick">
						<fa icon="reply"/>
					</button>
				</div>
				<input v-if="!queryVal" :readonly="!searchActive"
					type="text" v-model="query" :placeholder="paramsSearch.placeholder" class="form-control"/>
				<div class="input-group-append">
					<button class="btn btn-danger" @click="resetInput">
						<fa icon="times"/>
					</button>
				</div>
				<input type="text" v-model="rowSelectedId" class="form-control" hidden="" />
			</div>
			<div class="results" v-if="listOpen">
				<ul>
					<li v-for="row in rows" :key="row.id" @click="onClick(row)">
						<fa :icon="paramsSearch.icon ? paramsSearch.icon : 'user' "/>
						<span>{{ row[paramsSearch.attrView] }}</span>
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	name: 'AutoSearch',
	props: {
		paramsSearch: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			layoutBc: process.env.VUE_APP_STYLE_LAYOUT_BC || '#ecaf52',
			query: '',
			queryVal: '',
			rows: [],
			listOpen: false,
			searchActive: true,
			rowSelectedId: ''
		}  
	},
	watch: {
		query: function() {
			this.search();
		}
	},
	async mounted() {
		if(this.paramsSearch?.listOpen){
			this.rows = this.paramsSearch.filterList;
			this.listOpen = this.paramsSearch?.listOpen;
		}
		if(this.paramsSearch?.defaultValue){
			this.query = this.paramsSearch?.defaultValue;
			this.searchActive = false
			// this.listOpen = false
		}
	},
	methods: {
		resetInput(){
			this.query = ''; 
			this.searchActive = true; 
			this.rowSelectedId = ''; 
			this.queryVal = '';
		},
		async removeLinkObject(){
			/*await this.$store.dispatch('axiosPut', {
				domain: 'secuser',
				id: this.linkObject.secUserId + '/unlinkgisentity',
				data: {entityCls: this.linkObject.oldEntityCls, entityId: this.linkObject.oldEntityId}
			})
			.then(response => {
				console.log('UnLink - Succeess');
			}).catch(error => {
				console .log('UnLink - error == ', error.response);
			})*/
		},
		async search() { 
			if(this.query.length > 1 && this.searchActive === true) {
				
				if(this.paramsSearch.filterList){
					this.rows = this.paramsSearch.filterList.filter(item => 
						item[this.paramsSearch.attrView].toLowerCase().includes(this.query.toLowerCase())
					)
					this.listOpen = true;
				}
				else {
					let strParams = "logCr=or&typeRender=list"
					let attrsSearch = this.paramsSearch.attrsSearch;
					for (let i = 0; i < attrsSearch.length; i++) {
						let index = i+1;
						strParams = strParams+ "&params"+ index + "="+attrsSearch[i]+ "&valParams"+ index + "="+ this.query +"&logParams"+ index + "=ilike"  
					}
					await this.$store.dispatch('axiosGet', { url: '/api/'+ this.paramsSearch.instanceClass+'/getbycriteria?' + strParams
					})
					.then(response => {
						if(response.data){
							this.listOpen = true;
							this.rows = response.data;
						}
					}).catch(error => {
						console.log('error catch == ', error.message)
					})
				}

			} 
			else {
				//this.query = '';
				this.rows = [];
				this.listOpen = false;
			}
		},
		onClick(row) {
			this.searchActive = false
			if(row && row.id){
				this.query = row[this.paramsSearch.attrView];
				this.rowSelectedId = row.id;
				this.listOpen = false;
				// SI LISTE SEND, ON RENVOI
				if(this.paramsSearch.filterList){
					this.$emit('updateOnClick', row);
					if(this.paramsSearch.btnReturn)
						this.resetInput() 
				}
				else if(this.paramsSearch.updateOnClick)
					this.$emit('updateOnClick', row);
			}
			else {
				// return 
				this.$emit('updateOnClick');
				if(this.paramsSearch.btnReturn)
					this.resetInput()
			}
		}

	}
}
</script>

<style scoped>
	
	.searchbox {
		padding: 10px 0 0 0;
		text-align: center;
		width: 100%;
		margin: 1%;

	}
	.results {
		margin: 1%;
		display: flex;
	}
	.results ul {
		background-color:white;
		display: block;
		padding: 3px 2px;
		clear: both;
		font-weight: 400;
		line-height: 1.42857143;
		white-space: nowrap;
		border: 1px solid #c5ccd6;
		border-radius: 0.35rem;
		width: 101%;
	}
	.results li {
		padding: 5px;
		border-bottom: 1px 1px dotted #DB04CC;
		display: flex;
		align-items: center;
	}
	.results li:hover {
		color: white;
		background-color: v-bind('layoutBc');
		cursor: pointer;
	}
	.results li span {
		display: inline-block;
		margin-left: 20px;
	}

</style>